import { useNavigate } from 'react-router-dom';
import { useCacheBuster } from 'react-cache-buster';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
// mui
import { Stack, Typography, Box, CircularProgress } from '@mui/material';
// component
import ArrowLinkButton from '@/component/common/arrow-link-button';
// api
import { logout, readVersion } from '@/api/server/user/read';
// hook
import { useWeb3 } from '@/hooks/use-web3';
// import useWeb3UserInfo from '@/hooks/web3/useWeb3UserInfo';
// lib & store
import { deleteStorage, localDeleteStorage, localGetStorage } from '@/lib/storage';
import packageJson from '../../../../package.json';
import { SFPalette } from '@/lib/color';
import { disconnectDeepLink } from '@/api/server/ErrorRes';
import { useWeb3AuthDisconnect } from '@web3auth/modal/react';

// 버전정보 이용약관 챗봇상담 로그아웃
export default function ListBundleNotice() {
  const { t } = useTranslation();
  const version = packageJson.version;
  const { checkCacheStatus } = useCacheBuster();
  const navigate = useNavigate();
  const { disconnect, loading } = useWeb3AuthDisconnect();
  const { clearWeb3Auth } = useWeb3();

  // 로그아웃 로딩 상태 관리
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logoutBtn = async () => {
    try {
      setIsLoggingOut(true);
      await disconnect();

      deleteStorage('url');
      localDeleteStorage('auth');
      clearWeb3Auth();

      // disconnect가 완전히 끝날 때까지 대기
    } catch (error) {
      console.error('로그아웃 중 에러 발생:', error);
    } finally {
      setIsLoggingOut(false);
      navigate('/');
    }
  };
  // 로그아웃 로딩 중일 때 로딩 화면 표시
  if (isLoggingOut) {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh" gap={2}>
        <CircularProgress size={60} />
        <Typography variant="h6" color="primary">
          로그아웃 중...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          잠시만 기다려주세요
        </Typography>
      </Box>
    );
  }

  return (
    <Stack mb={1.5} bgcolor="white" borderRadius={2}>
      {[
        // 2차 예정
        // {
        //   name: '1:1 문의',
        //   src: '/wallet/nft',
        // },
        {
          name: `${t('validation.versionInfo')}`,
          src: '',
          version: { version },
        },
        {
          name: `${t('validation.agreeTerms')}`,
          src: '/terms',
        },
        {
          name: `${t('validation.ChatbotCs')}`,
          src: 'https://pf.kakao.com/_DRxfMG',
        },
        {
          name: `${t('validation.logout')}`,
          src: '/signInSns',
        },
      ].map((item, index) => (
        <ArrowLinkButton
          key={(item.name + '-', index)}
          onClick={() => {
            if (item.name === t('validation.logout')) {
              logoutBtn();
              return;
            } else if (item.name === t('validation.versionInfo')) {
              console.log(`버전정보업데이트`);
              const clientVersion = version;
              readVersion().then((serverResponse) => {
                console.log(`serverResponse: ${serverResponse}`);
                const serverVersion = serverResponse?.data.version;
                console.log(`serverVersion: ${serverVersion}`);
                if (!serverVersion) {
                  console.log('Server version not found');
                  return;
                }
                if (serverVersion !== clientVersion) {
                  sessionStorage.setItem('version-check-reloaded', 'true');
                  window.location.reload();
                }
              });
              checkCacheStatus();
              return;
            } else if (item.name === t('validation.ChatbotCs')) {
              document.location = item.src;
              return;
            }
            navigate(item?.src);
          }}
          sx={{
            borderBottom: `1px solid #F5F5F5`,
          }}
          buttonProps={{
            sx: {
              width: '100%',
              px: 3,
              py: 1.5,
            },
          }}
          stackProps={{
            width: '100%',
            justifyContent: 'space-between',
            borderRadius: 2,
          }}
          typographyProps={{
            variant: 'subtitle2',
          }}
          rightItem={
            item.version && (
              <Typography variant="subtitle2" color={SFPalette.grey2} mr={1} sx={{}}>
                {version}
              </Typography>
            )
          }
        >
          {item.name}
        </ArrowLinkButton>
      ))}
    </Stack>
  );
}
